import {ChangeDetectionStrategy, Component, Input} from "@angular/core";
import {EnkelGruppeModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {GruppeLogoKomponent, Stil} from "./gruppe-logo";


/**
 * Wrapper rundt <gruppe-logo> for bruk i ajs
 */
@Component({
    selector: 'gruppe-logo-ajs',
    template: '<gruppe-logo [gruppe]="gruppe" [stil]="stil"/>',
    imports: [
        GruppeLogoKomponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GruppeLogoAjsKomponent {
    static ajsSelector = 'gruppeLogoAjs';

    @Input({required: true}) gruppe!: EnkelGruppeModell;
    @Input() stil: Stil = '';

    constructor() {
    }
}
